import { useContext } from "react";
import { AuthContext } from "../components/auth/Auth";

export default () => {
  const { currentUser } = useContext(AuthContext);

  return currentUser;
};
